import { useContext } from 'react';

import { ChartContext } from '../context';

export const useChartContext = () => useContext(ChartContext);



// WEBPACK FOOTER //
// ./src/components/common/Charts/hooks/useChartContext.js